export const CheatReelsSetMatrixEvents = {
    FORCE_UPDATE: Symbol('forceUpdate')
} as const;